import {useLocation} from '@github-ui/react-router'
import {ssrSafeWindow} from '@github-ui/ssr-utils'
import {useEffect} from 'react'

/**
 * Restores scroll position from React Router location state on the initial render.
 */
export function useRouterScrollRestoration() {
  const location = useLocation()
  const restoreScrollY = (location.state as {restoreScrollY?: number} | null)?.restoreScrollY

  useEffect(() => {
    if (restoreScrollY === undefined) return
    const frame = requestAnimationFrame(() => {
      ssrSafeWindow?.scrollTo(0, restoreScrollY)
    })
    return () => cancelAnimationFrame(frame)
  }, [restoreScrollY])
}
